function s4(): string {
   return Math.random().toString(16).substring(2, 6);
}

export function Guid(): string {
   return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}
